import styled from 'styled-components';

export default styled.p`
  font-size: 14px;
  color: var(--error-500);
  margin: 0;
  background: rgba(255, 0, 0, 0.2);
  font-family: Roboto;
  border-radius: 4px;
  padding: 2px;
`;
